import clsx from "clsx";
import React from "react";
import ReactHtmlParser from "react-html-parser";

const Blockquote = ({ quote, attribution }) => {
  return (
    <blockquote className={clsx("Blockquote", "")}>
      <div
        className={clsx(
          "Blockquote__content",
          " text-3xl font-light md:text-4xl"
        )}
      >
        {ReactHtmlParser(quote)}
      </div>
      {!!attribution && (
        <footer
          className={clsx(
            "Blockquote__attribution",
            "text-md mt-4  text-gray-600 md:text-lg"
          )}
        >
          — {attribution}
        </footer>
      )}
    </blockquote>
  );
};

export default Blockquote;
